var cov_1yfyo0yv1z = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/validate/type.ts",
      hash = "8925e376466d2218025524648c3668bf000b1370",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/validate/type.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 20
        },
        end: {
          line: 71,
          column: 1
        }
      },
      "1": {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 939
        }
      },
      "2": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 26
        }
      },
      "3": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 41
        }
      },
      "4": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 27
        }
      },
      "5": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 29
        }
      },
      "6": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 25,
          column: 5
        }
      },
      "7": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 30,
          column: 5
        }
      },
      "8": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 173
        }
      },
      "9": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 69,
          column: 5
        }
      },
      "10": {
        start: {
          line: 76,
          column: 2
        },
        end: {
          line: 105,
          column: 4
        }
      },
      "11": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 81,
          column: 5
        }
      },
      "12": {
        start: {
          line: 80,
          column: 6
        },
        end: {
          line: 80,
          column: 32
        }
      },
      "13": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 85,
          column: 5
        }
      },
      "14": {
        start: {
          line: 84,
          column: 6
        },
        end: {
          line: 84,
          column: 34
        }
      },
      "15": {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 92,
          column: 5
        }
      },
      "16": {
        start: {
          line: 88,
          column: 6
        },
        end: {
          line: 89,
          column: 26
        }
      },
      "17": {
        start: {
          line: 88,
          column: 25
        },
        end: {
          line: 88,
          column: 39
        }
      },
      "18": {
        start: {
          line: 89,
          column: 11
        },
        end: {
          line: 89,
          column: 26
        }
      },
      "19": {
        start: {
          line: 91,
          column: 6
        },
        end: {
          line: 91,
          column: 12
        }
      },
      "20": {
        start: {
          line: 94,
          column: 16
        },
        end: {
          line: 94,
          column: 26
        }
      },
      "21": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 98,
          column: 5
        }
      },
      "22": {
        start: {
          line: 96,
          column: 6
        },
        end: {
          line: 96,
          column: 61
        }
      },
      "23": {
        start: {
          line: 97,
          column: 6
        },
        end: {
          line: 97,
          column: 75
        }
      },
      "24": {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 104,
          column: 5
        }
      },
      "25": {
        start: {
          line: 101,
          column: 6
        },
        end: {
          line: 101,
          column: 20
        }
      },
      "26": {
        start: {
          line: 103,
          column: 6
        },
        end: {
          line: 103,
          column: 21
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 2
          },
          end: {
            line: 7,
            column: 3
          }
        },
        loc: {
          start: {
            line: 7,
            column: 14
          },
          end: {
            line: 9,
            column: 3
          }
        },
        line: 7
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 3
          }
        },
        loc: {
          start: {
            line: 10,
            column: 16
          },
          end: {
            line: 12,
            column: 3
          }
        },
        line: 10
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 13,
            column: 3
          }
        },
        loc: {
          start: {
            line: 13,
            column: 15
          },
          end: {
            line: 15,
            column: 3
          }
        },
        line: 13
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 3
          }
        },
        loc: {
          start: {
            line: 16,
            column: 12
          },
          end: {
            line: 18,
            column: 3
          }
        },
        line: 16
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 3
          }
        },
        loc: {
          start: {
            line: 19,
            column: 12
          },
          end: {
            line: 21,
            column: 3
          }
        },
        line: 19
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        },
        loc: {
          start: {
            line: 22,
            column: 12
          },
          end: {
            line: 26,
            column: 3
          }
        },
        line: 22
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        },
        loc: {
          start: {
            line: 27,
            column: 13
          },
          end: {
            line: 31,
            column: 3
          }
        },
        line: 27
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 3
          }
        },
        loc: {
          start: {
            line: 32,
            column: 13
          },
          end: {
            line: 34,
            column: 3
          }
        },
        line: 32
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 35,
            column: 3
          }
        },
        loc: {
          start: {
            line: 35,
            column: 12
          },
          end: {
            line: 70,
            column: 3
          }
        },
        line: 35
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 75,
            column: 15
          },
          end: {
            line: 75,
            column: 16
          }
        },
        loc: {
          start: {
            line: 76,
            column: 2
          },
          end: {
            line: 105,
            column: 4
          }
        },
        line: 76
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 76,
            column: 11
          },
          end: {
            line: 76,
            column: 12
          }
        },
        loc: {
          start: {
            line: 76,
            column: 94
          },
          end: {
            line: 105,
            column: 3
          }
        },
        line: 76
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 81,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 81,
            column: 5
          }
        }, {
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 81,
            column: 5
          }
        }],
        line: 79
      },
      "1": {
        loc: {
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 85,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 85,
            column: 5
          }
        }, {
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 85,
            column: 5
          }
        }],
        line: 83
      },
      "2": {
        loc: {
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 92,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 92,
            column: 5
          }
        }, {
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 92,
            column: 5
          }
        }],
        line: 87
      },
      "3": {
        loc: {
          start: {
            line: 88,
            column: 6
          },
          end: {
            line: 89,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 88,
            column: 6
          },
          end: {
            line: 89,
            column: 26
          }
        }, {
          start: {
            line: 88,
            column: 6
          },
          end: {
            line: 89,
            column: 26
          }
        }],
        line: 88
      },
      "4": {
        loc: {
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 98,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 98,
            column: 5
          }
        }, {
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 98,
            column: 5
          }
        }],
        line: 95
      },
      "5": {
        loc: {
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 104,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 104,
            column: 5
          }
        }, {
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 104,
            column: 5
          }
        }],
        line: 100
      },
      "6": {
        loc: {
          start: {
            line: 100,
            column: 8
          },
          end: {
            line: 100,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 100,
            column: 8
          },
          end: {
            line: 100,
            column: 33
          }
        }, {
          start: {
            line: 100,
            column: 37
          },
          end: {
            line: 100,
            column: 52
          }
        }],
        line: 100
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import nullable from './nullable';
import isJson from './isJson';

/* eslint-disable */
export var regs = (cov_1yfyo0yv1z.s[0]++, {
  get email() {
    cov_1yfyo0yv1z.f[0]++;
    cov_1yfyo0yv1z.s[1]++;
    return /^((([a-zA-Z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-zA-Z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/;
  },

  get integer() {
    cov_1yfyo0yv1z.f[1]++;
    cov_1yfyo0yv1z.s[2]++;
    return /^[-+]?[0-9]*$/;
  },

  get number() {
    cov_1yfyo0yv1z.f[2]++;
    cov_1yfyo0yv1z.s[3]++;
    return /^-?(\d*\.)?\d+(e[-+]?\d+)?$/i;
  },

  get tel() {
    cov_1yfyo0yv1z.f[3]++;
    cov_1yfyo0yv1z.s[4]++;
    return /^[\d\s ().-]+$/;
  },

  get hex() {
    cov_1yfyo0yv1z.f[4]++;
    cov_1yfyo0yv1z.s[5]++;
    return /^#[0-9a-f]{6}?$/i;
  },

  get rgb() {
    cov_1yfyo0yv1z.f[5]++;
    cov_1yfyo0yv1z.s[6]++;
    return new RegExp('^rgb\\(\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*\\)$');
  },

  get rgba() {
    cov_1yfyo0yv1z.f[6]++;
    cov_1yfyo0yv1z.s[7]++;
    return new RegExp('^rgba\\(\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*((0.[1-9]*)|[01])\\s*\\)$');
  },

  get ipv4() {
    cov_1yfyo0yv1z.f[7]++;
    cov_1yfyo0yv1z.s[8]++;
    return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  },

  get url() {
    cov_1yfyo0yv1z.f[8]++;
    cov_1yfyo0yv1z.s[9]++;
    return new RegExp('^' + // protocol identifier
    '(?:(?:https?|ftp)://)?' + // ** mod: make scheme optional
    // user:pass authentication
    '(?:\\S+(?::\\S*)?@)?' + '(?:' + // IP address exclusion
    // private & local networks
    // "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +   // ** mod: allow local networks
    // "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +  // ** mod: allow local networks
    // "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +  // ** mod: allow local networks
    // IP address dotted notation octets
    // excludes loopback network 0.0.0.0
    // excludes reserved space >= 224.0.0.0
    // excludes network & broacast addresses
    // (first & last IP address of each class)
    '(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' + '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' + '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' + '|' + // host name
    "(?:(?:[a-zA-Z\\u00a1-\\uffff0-9]-*)*[a-zA-Z\\u00a1-\\uffff0-9]+)" + // domain name
    "(?:\\.(?:[a-zA-Z\\u00a1-\\uffff0-9]-*)*[a-zA-Z\\u00a1-\\uffff0-9]+)*" + // TLD identifier
    "(?:\\.(?:[a-zA-Z\\u00a1-\\uffff]{2,}))" + ')' + // port number
    '(?::\\d{2,5})?' + // resource path
    '(?:/\\S*)?' + '$');
  }

});
/* eslint-enable */

export default (function (type, message) {
  cov_1yfyo0yv1z.f[9]++;
  cov_1yfyo0yv1z.s[10]++;
  return nullable(function (value, _formdata, callback) {
    cov_1yfyo0yv1z.f[10]++;
    var error;
    cov_1yfyo0yv1z.s[11]++;

    if (typeof message === 'string') {
      cov_1yfyo0yv1z.b[0][0]++;
      cov_1yfyo0yv1z.s[12]++;
      error = new Error(message);
    } else {
      cov_1yfyo0yv1z.b[0][1]++;
    }

    cov_1yfyo0yv1z.s[13]++;

    if (typeof message === 'function') {
      cov_1yfyo0yv1z.b[1][0]++;
      cov_1yfyo0yv1z.s[14]++;
      error = new Error(message());
    } else {
      cov_1yfyo0yv1z.b[1][1]++;
    }

    cov_1yfyo0yv1z.s[15]++;

    if (type === 'json') {
      cov_1yfyo0yv1z.b[2][0]++;
      cov_1yfyo0yv1z.s[16]++;

      if (isJson(value)) {
        cov_1yfyo0yv1z.b[3][0]++;
        cov_1yfyo0yv1z.s[17]++;
        callback(true);
      } else {
        cov_1yfyo0yv1z.b[3][1]++;
        cov_1yfyo0yv1z.s[18]++;
        callback(error);
      }

      cov_1yfyo0yv1z.s[19]++;
      return;
    } else {
      cov_1yfyo0yv1z.b[2][1]++;
    }

    var reg = (cov_1yfyo0yv1z.s[20]++, regs[type]);
    cov_1yfyo0yv1z.s[21]++;

    if (!reg) {
      cov_1yfyo0yv1z.b[4][0]++;
      cov_1yfyo0yv1z.s[22]++;
      console.error(new Error("Type '".concat(type, "' not existed.")));
      cov_1yfyo0yv1z.s[23]++;
      callback(new Error("Validate failured. Type '".concat(type, "' not existed.")));
    } else {
      cov_1yfyo0yv1z.b[4][1]++;
    }

    cov_1yfyo0yv1z.s[24]++;

    if ((cov_1yfyo0yv1z.b[6][0]++, typeof value === 'string') && (cov_1yfyo0yv1z.b[6][1]++, reg.test(value))) {
      cov_1yfyo0yv1z.b[5][0]++;
      cov_1yfyo0yv1z.s[25]++;
      callback(true);
    } else {
      cov_1yfyo0yv1z.b[5][1]++;
      cov_1yfyo0yv1z.s[26]++;
      callback(error);
    }
  });
});